<template>
	<div class="px-5">
		<app-table
			selectable
			row-maintenance
			class="mt-5"
			name="templates"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="$emit('on-page', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
				>
					<div style="display: flex; justify-content: flex-start; align-items: center; width: 100%;">
						<app-tooltip-button
							v-if="props.row.flagMaintenance"
							color="black"
							icon="announcement"
							text="En Mantenimiento"
						/>
						<span style="flex-grow: 1; text-align: center; display: flex; justify-content: center; align-items: center;">
							{{ props.row.name }}
						</span>
					</div>
				</td>
				<td>
					{{ props.row.description }}
				</td>
				<td>
					<app-tooltip-button
						color="blue"
						icon="create"
						text="Editar Nombre"
						@click-icon="editName(props.row)"
					/>
					<app-tooltip-button
						color="green"
						icon="visibility"
						text="Detalle"
						@click-icon="detail(props.row.id)"
					/>
					<app-tooltip-button
						color="blue"
						icon="add_circle_outline"
						text="Nueva Compañia"
						@click-icon="newTemplate(props.row)"
					/>
					<app-tooltip-button
						color="infor"
						icon="developer_board"
						text="Distribución de roles"
						@click-icon="rolesDistribution(props.row)"
					/>
					<!-- <app-tooltip-button
						color="info"
						icon="cached"
						text="Distrib. Recursos"
						@click-icon="resource(props.row)"
					/> -->
					<app-tooltip-button
						:color="props.row.flagSyncCompanies === 0? 'cyan' : 'warning'"
						icon="cloud_sync"
						:text="props.row.flagSyncCompanies === 0? 'Sincronizado' : 'Pendiente'"
						@click-icon="resource(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="highlight_off"
						text="Eliminar"
					/>
					<app-tooltip-button
						color="blue"
						text="Configurar Procesos"
						icon="build"
						@click-icon="configurationProcess(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						text="Configuracion"
						icon="settings"
						@click-icon="configuration(props.row)"
					/>
					<v-tooltip top v-if="codeProject === 'maki_project'"  >
						<v-btn
							flat
							icon
							small
							slot="activator"
							color="blue"
							@click="setStructureCompany(props.row)">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gamepad-icon lucide-gamepad"><line x1="6" x2="10" y1="12" y2="12"/><line x1="8" x2="8" y1="10" y2="14"/><line x1="15" x2="15.01" y1="13" y2="13"/><line x1="18" x2="18.01" y1="11" y2="11"/><rect width="20" height="12" x="2" y="6" rx="2"/></svg>

						</v-btn>
						<span>Asignar Niveles y Tareas a Compañias</span>
					</v-tooltip>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import helper from '@/shared/helper';

const { getLocalData, setLocalData } = helper;

function resource({ codeTemplate }) {
	this.goTo('page-distribution-of-resources', { params: { idDistribution: codeTemplate } });
}

function created() {
	this.idProject = this.projectId || getLocalData('project-id');
}

function detail(id) {
	this.goTo('page-template-detail', { params: { id, projectId: this.idProject } });
}

function newTemplate({ id, name, codeTemplate }) {
	setLocalData('code-template', codeTemplate);
	this.goTo('page-template-new', { params: { id, name, projectId: this.idProject, codeTemplate } });
}

function rolesDistribution({ id }) {
	this.goTo('page-resources-assignment', { params: { idTemplate: id } });
}

function editName({ id }) {
	this.goTo('page-template-edit', { params: { id, projectId: this.idProject } });
}

function configurationProcess({ codeTemplate, id }) {
	this.goTo('page-configuration-process', { params: { codeTemplate, id } });
}

function configuration({ id }) {
	this.goTo('page-configuration-general', { params: { idTemplate: id } });
}

async function setStructureCompany({ id }) {
	const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
	await this.$http.post('level-structure-template', { templateId: id }, { headers });
	this.showNotification('Se asignaron los niveles y tareas a las compañias');
}

function data() {
	return {
		idProject: 0,
	};
}

export default {
	name: 'template-list',
	components: {
		appTooltipButton,
	},
	created,
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		codeProject: {
			type: String,
		},
		projectId: {
			type: [Number, String],
		},
	},
	methods: {
		configurationProcess,
		detail,
		newTemplate,
		rolesDistribution,
		resource,
		editName,
		configuration,
		setStructureCompany,
		onSearch(value) {
			this.$emit('on-search', value);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/template/template-list.vue